export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10743.08899c09.jpg";